// extracted by mini-css-extract-plugin
export default {"content":"ItemViewer__content--2VyjQ","contentMessage":"ItemViewer__contentMessage--9uLSu"};